import CloseIcon from '@/src/assets/svgs/CloseIcon'
import { Benefit, VasAncillary } from '@/src/types/itinerary'
import { isEmpty } from '@/src/utils/generalUtils'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import {
    Box,
    Button,
    Card,
    Checkbox,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    Link,
    Typography
} from '@mui/material'
import { useLocale } from 'next-intl'
import { useState } from 'react'

type LocaleKey = 'en' | 'ar'

// export const paxTypeMap: Record<LocaleKey, Record<PassengerType, string>> = {
//     en: {
//         ADT: 'Adults',
//         CHD: 'Children',
//         INF: 'Infants'
//     },
//     ar: {
//         ADT: 'بالغين',
//         CHD: 'أطفال',
//         INF: 'أطفال'
//     }

// }


const contentMap: Record<
    LocaleKey,
    {
        headerTitle: string
        radioTitle: string
        insureTitle: string
        viewPolicyBenefits: string
        termsAndConditions: string
        priceSuffix: string
        add: string
        remove: string
        close: string
        defaultBenefits: Benefit[]
    }
> = {
    en: {
        headerTitle: 'Baggage protection',
        radioTitle: 'Secure your trip for baggage delay & loss',
        insureTitle: 'Insure your trip to get reimbursed in case of unexpected events.',
        viewPolicyBenefits: 'View policy benefits',
        termsAndConditions: 'Terms & conditions',
        priceSuffix: 'per traveller',
        add: 'Add',
        remove: 'Remove',
        close: 'Close',
        defaultBenefits: [
            {
                icon: 'https://ui.cltp.co/images/bento/insurance/baggage_delay-175.png',
                title: 'Real-time status notifications',
                amount: 0
            },
            {
                icon: 'https://ui.cltp.co/images/bento/insurance/quick_approval-175.png',
                title: 'Payout guaranteed post 96 hrs',
                amount: 0
            },
            {
                icon: 'https://ui.cltp.co/images/bento/insurance/paperless_claim-175.png',
                title: 'Paperless reporting process',
                amount: 0
            },
            {
                icon: 'https://ui.cltp.co/images/bento/insurance/cash-175.png',
                title: 'Payments above airline/insurance compensation',
                amount: 0
            }
        ]
    },
    ar: {
        headerTitle: 'حماية الأمتعة',
        radioTitle: 'أمّن رحلتك ضد تأخير وفقدان الأمتعة',
        insureTitle: 'أمّن رحلتك للحصول على تعويض في حالة الأحداث غير المتوقعة.',
        viewPolicyBenefits: 'عرض مزايا الوثيقة',
        termsAndConditions: 'الشروط والأحكام',
        priceSuffix: 'لكل مسافر',
        add: 'إضافة',
        remove: 'إزالة',
        close: 'إغلاق',
        defaultBenefits: [
            {
                icon: 'https://ui.cltp.co/images/bento/insurance/baggage_delay-175.png',
                title: 'إشعارات فورية بحالة الأمتعة',
                amount: 0
            },
            {
                icon: 'https://ui.cltp.co/images/bento/insurance/quick_approval-175.png',
                title: 'ضمان صرف التعويض بعد 96 ساعة',
                amount: 0
            },
            {
                icon: 'https://ui.cltp.co/images/bento/insurance/paperless_claim-175.png',
                title: 'إجراءات إبلاغ بدون أوراق',
                amount: 0
            },
            {
                icon: 'https://ui.cltp.co/images/bento/insurance/cash-175.png',
                title: 'تعويض أعلى من تعويض شركة الطيران أو التأمين',
                amount: 0
            }
        ]
    }
}

const TripAddLPCTItemCard = ({
    insurance,
    index,
    isSelected,
    onInsuranceClick,
    formatCurrency,
    globalTermsAndConditionsUrl
}: {
    insurance: VasAncillary
    index: number
    isSelected: boolean
    onInsuranceClick: () => void
    formatCurrency: (amount: number) => string
    globalTermsAndConditionsUrl: string
}) => {
    const locale = useLocale()
    const [isBenefitsOpen, setIsBenefitsOpen] = useState(false)
    const isArabic = locale === 'ar'
    const content = contentMap[isArabic ? 'ar' : 'en']
    const vasDetail = insurance.vasDetails?.[0]

    const {
        text: title = '',
        description = '',
        tripPremiumDetails,
        benefits = [],
        termsAndConditions: { url: termsUrl = '' } = {},
        provider = ''
    } = vasDetail || {}

    const { paxTypePremiumDetails = [] } = tripPremiumDetails || {}
    const { singlePaxPremiumDetails = {} } = paxTypePremiumDetails?.[0] || {}
    const { totalPremiumAmount: perTravellerPremiumAmount = 0 } = singlePaxPremiumDetails as { totalPremiumAmount: number }
    const insurancePriceText = !isEmpty(perTravellerPremiumAmount)
        ? `${formatCurrency(perTravellerPremiumAmount)} ${content.priceSuffix}`
        : `${formatCurrency(tripPremiumDetails.totalPremiumAmount)}`

    const cardBenefits = (benefits?.length ? benefits : content.defaultBenefits).slice(0, 4)
    const cardId = `${insurance.vasType}_${index}`
    // const itineraryId = useGetItineraryId()
    // const { paxInfo } = useGetItineraryDataQuery(
    //     {
    //         itineraryId
    //     },
    //     {
    //         selectFromResult: ({ data }) => ({
    //             paxInfo: data?.searchCriteria?.paxInfo
    //         })
    //     }

    // )
    // const shouldShowPaxEligibilityNote = useMemo(() => {
    //     const getEligiblePaxDetailsFromPaxTypeMapKey = (key: string) => {
    //         return tripPremiumDetails?.paxTypePremiumDetails?.find((pax: Record<string, any>) => pax.paxType === key)
    //     }

    //     let showNote = false

    //     const paxTypeMapEntries = Object.entries(paxTypeMap['en'])
    //     for (const [key, value] of paxTypeMapEntries) {
    //         const eligiblePaxDetails = getEligiblePaxDetailsFromPaxTypeMapKey(key)

    //         const paxInfoValue = paxInfo?.[value?.toLowerCase() as keyof PaxInfo]
    //         console.log({
    //             paxInfo,
    //             key,
    //             value,
    //             eligiblePaxDetails,
    //             paxInfoValue
    //         })
    //         if (paxInfoValue && paxInfoValue > 0 && paxInfoValue !== eligiblePaxDetails?.paxCount) {
    //             showNote = true
    //             break
    //         }
    //     }
    //     return showNote
    // }, [paxInfo, tripPremiumDetails])


    return (
        <Card
            key={cardId}
            id={cardId}
            sx={
                {
                    borderRadius: 2,
                }
            }

        >
            <Box sx={{ px: 2, py: 1 }}>
                <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: 600,
                        mb: 1,

                    }}
                >
                    {content.headerTitle}
                </Typography>

                <Box
                    onClick={onInsuranceClick}
                    sx={{
                        display: 'flex',
                        gap: 0.2,
                        alignItems: 'center',
                        cursor: 'pointer'
                    }}
                >
                    <Checkbox
                        checked={isSelected}
                        icon={<RadioButtonUncheckedIcon />}
                        checkedIcon={<CheckCircleIcon />}
                        sx={{
                            p: 0.5,

                            '&.Mui-checked': {
                                color: 'primary.main'
                            }
                        }}
                    />
                    <Box>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                color: 'text.primary',
                                // mb: 0.5,
                            }}
                        >
                            {content.radioTitle}
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '12px',
                                color: 'text.secondary',

                            }}
                        >
                            {insurancePriceText}
                        </Typography>
                    </Box>

                </Box>
            </Box>

            <Divider />

            <Box sx={{ px: 2, pt: 1, pb: 2 }}>
                <Typography
                    sx={{
                        fontSize: '14px',
                        color: 'text.secondary',
                        mb: 1.5,

                    }}
                >
                    {content.insureTitle}
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 0.1, mb: 1.5 }}>
                    {cardBenefits.map((benefit, benefitIndex) => (
                        <Box key={`${benefit.title}_${benefitIndex}`} sx={{ textAlign: 'center' }}>
                            <Box component="img" src={benefit.icon} alt={benefit.title} sx={{ width: 32, height: 32, mb: 0.5 }} />
                            <Typography sx={{ fontSize: '11px', color: 'text.secondary', lineHeight: 1.2 }}>
                                {benefit.title}
                            </Typography>
                        </Box>
                    ))}
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography
                        onClick={() => setIsBenefitsOpen(true)}
                        sx={{
                            color: 'primary.main',
                            fontSize: '14px',
                            cursor: 'pointer',
                            textDecoration: 'underline'
                        }}
                    >
                        {content.viewPolicyBenefits}
                    </Typography>
                    <Box
                        component="img"
                        src="https://app.tripadd.com/assets/tripadd/logo.png"
                        alt={provider || 'provider'}
                        sx={{ width: 50, height: 'auto' }}
                    />
                </Box>
            </Box>

            <Dialog
                open={isBenefitsOpen}
                onClose={() => setIsBenefitsOpen(false)}
                fullWidth
                maxWidth="md"

            >
                <Box sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <DialogTitle sx={{ p: 0, mb: 1, }}>{title}</DialogTitle>
                        <IconButton onClick={() => setIsBenefitsOpen(false)} sx={{
                            position: 'absolute',
                            right: 16,
                            top: 16,
                            bgcolor: 'grey.100',
                            '&:hover': {
                                bgcolor: 'grey.200'
                            }
                        }} size='small'><CloseIcon /></IconButton>
                    </Box>

                    <Box
                        sx={{
                            fontSize: '14px',
                            color: 'text.secondary',

                        }}
                        dangerouslySetInnerHTML={{ __html: description || '' }}
                    />
                </Box>
                <DialogContent sx={{ pt: 0 }}>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                        <Box>
                            <Typography sx={{ fontSize: '14px', fontWeight: 600, mb: 0.5 }}>{insurancePriceText}</Typography>
                            <Link
                                href={termsUrl || globalTermsAndConditionsUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="always"
                                sx={{ fontSize: '12px' }}
                            >
                                {content.termsAndConditions}
                            </Link>
                        </Box>
                        <Button
                            variant={isSelected ? 'contained' : 'outlined'}
                            size="small"
                            sx={{
                                minWidth: 96,
                                textTransform: 'none',
                                fontWeight: 500,
                                borderRadius: 1,
                                borderColor: 'primary.main'
                            }}
                            onClick={() => {
                                onInsuranceClick()
                                setIsBenefitsOpen(false)
                            }}
                        >
                            {isSelected ? content.remove : content.add}
                        </Button>
                    </Box>
                </DialogContent>

            </Dialog>
        </Card>
    )
}

export default TripAddLPCTItemCard
